import { ReactNode } from 'react';

import { Link, Tooltip, type LinkRouteMapping } from 'components/Blocks';

import { cn } from 'styles';

import { useAppWrapper } from '../WrapperContext';

type ToOptions = LinkRouteMapping[keyof LinkRouteMapping];

type SideLinkProps = ToOptions & {
  label: ReactNode;
  icon: ReactNode;
  tooltipContent?: ReactNode;

  disableTooltip?: boolean;
};

export function SideLink({ icon, label, tooltipContent, disableTooltip, ...props }: SideLinkProps) {
  const { showIconOnly, escapeDrawer } = useAppWrapper();

  // const shouldHighlight = useIsRoute(props.to, { matchPrefix: true });

  return (
    <Tooltip
      position="right"
      arrow
      disabled={!showIconOnly || disableTooltip}
      className="text-muted-foreground"
      content={tooltipContent ?? label}
    >
      <Link
        {...props}
        draggable={false}
        onClick={escapeDrawer}
        className={cn(
          'bg-primary-foreground text-primary hover:bg-primary-light hover:text-primary-foreground dark:bg-accent dark:text-accent-foreground dark:hover:bg-hover',
          'inline-flex w-full items-center justify-between gap-2 whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors',
          showIconOnly &&
            'mx-auto gap-0 rounded-lg bg-transparent p-1 text-primary-foreground dark:text-card-foreground',
          // shouldHighlight && 'bg-primary-light text-primary-foreground',
        )}
      >
        {icon}

        <span
          className={cn(
            'transition-opacity duration-300',
            showIconOnly ? 'w-0 opacity-0' : 'opacity-1',
          )}
        >
          {label}
        </span>

        <span />
      </Link>
    </Tooltip>
  );
}
